import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Icon, type IconName } from '@/components/foundations';

export type IconButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  icon: IconName;
  /** Obrigatório: vira o `aria-label`. */
  label: string;
  /** `plain` = sem borda/fundo (topo do checkout). */
  variant?: 'outline' | 'plain';
  /** Selo numérico (ex.: notificações). */
  badge?: ReactNode;
};

/** Botão só com ícone (`.iconbtn`). */
export function IconButton({ icon, label, variant = 'outline', badge, className = '', ...rest }: IconButtonProps) {
  return (
    <button type="button" className={['iconbtn', variant === 'plain' ? 'plain' : '', className].filter(Boolean).join(' ')} aria-label={label} {...rest}>
      <Icon name={icon} />
      {badge !== undefined && <span className="n">{badge}</span>}
    </button>
  );
}
